import { useState } from "react";
import { ChevronDown, ExternalLink, Database } from "lucide-react";

// Daftar tautan data eksternal yang ditampilkan sebagai dropdown. Setiap item
// bisa dibuka, lalu menampilkan tombol "Lihat Data" yang membuka tautan di tab
// baru. Dipakai mis. pada halaman "Kemahasiswaan" (Data dan Laporan).
function LinkItem({ slug, label, href }) {
  const [open, setOpen] = useState(false);

  return (
    <div
      data-testid={`data-link-item-${slug}`}
      className="overflow-hidden rounded-2xl border border-[#BBDCF3] bg-white"
    >
      <button
        type="button"
        data-testid={`data-link-toggle-${slug}`}
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-[#F4FAFE]"
      >
        <span className="flex items-center gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#EFF6FC]">
            <Database aria-hidden="true" className="h-5 w-5 text-[#1479BF]" />
          </span>
          <span className="font-display text-base font-semibold md:text-lg">
            {label}
          </span>
        </span>
        <ChevronDown
          aria-hidden="true"
          className={`h-5 w-5 shrink-0 text-[#1479BF] transition-transform duration-300 ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>

      {open && (
        <div
          data-testid={`data-link-body-${slug}`}
          className="border-t border-[#E3F0FA] bg-[#FBFDFF] px-5 py-4"
        >
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`data-link-link-${slug}`}
            className="inline-flex items-center gap-2 rounded-full bg-[#1479BF] px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-[#0B5E99]"
          >
            Lihat Data
            <ExternalLink aria-hidden="true" className="h-4 w-4" />
          </a>
        </div>
      )}
    </div>
  );
}

export default function ExternalLinkSection({ items }) {
  return (
    <div data-testid="data-link-section" className="mt-10 space-y-3">
      {items.map((it) => (
        <LinkItem key={it.slug} {...it} />
      ))}
    </div>
  );
}
